import { useEffect } from "react";

export function useSeo({ title, description, canonical, image, type = "website", modifiedTime, publishedTime, robots = "index, follow" }) {
    useEffect(() => {
        if (title) document.title = title;
        const setMeta = (name, content) => {
            if (!content) return;
            let el = document.querySelector(`meta[name="${name}"]`);
            if (!el) {
                el = document.createElement("meta");
                el.setAttribute("name", name);
                document.head.appendChild(el);
            }
            el.setAttribute("content", content);
        };
        const setOg = (property, content) => {
            if (!content) return;
            let el = document.querySelector(`meta[property="${property}"]`);
            if (!el) {
                el = document.createElement("meta");
                el.setAttribute("property", property);
                document.head.appendChild(el);
            }
            el.setAttribute("content", content);
        };
        setMeta("description", description);
        // Explicite à chaque route (défaut « index, follow ») : évite qu'un « noindex »
        // posé par une page (ex. /app-bientot) reste collé après une navigation SPA.
        setMeta("robots", robots);
        setOg("og:title", title);
        setOg("og:description", description);
        setOg("og:type", type);
        if (canonical) setOg("og:url", canonical);
        if (image) {
            setOg("og:image", image);
            setMeta("twitter:card", "summary_large_image");
            setMeta("twitter:image", image);
        }
        if (type === "article" && publishedTime) {
            setOg("article:published_time", publishedTime);
        }
        if (type === "article" && modifiedTime) {
            setOg("article:modified_time", modifiedTime);
        }
        if (canonical) {
            let link = document.querySelector('link[rel="canonical"]');
            if (!link) {
                link = document.createElement("link");
                link.setAttribute("rel", "canonical");
                document.head.appendChild(link);
            }
            link.setAttribute("href", canonical);
        }
    }, [title, description, canonical, image, type, modifiedTime, publishedTime, robots]);
}
